module.exports = __webpack_public_path__ + "images/2.1791972770245.jpg";